module.exports = __webpack_public_path__ + "img/classic_thumbnail.1c8afe5e.jpg";